(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('toast', toast);

	toast.$inject = ['$rootScope', '$timeout', '$translate'];

	function toast($rootScope, $timeout, $translate) {
		var directive = {
			restrict: 'EA',
			templateUrl: 'toast.html',
			link: link
		};

		return directive;

		function link(scope, element, attrs) {
			var clearToastTimeout;
			scope.showToast = false;
			scope.showErrorToast = false;

			function addToastMessage(message, isSuccessful, time) {

				// Default Parameter doesn't work with minifier
				if(isSuccessful === undefined) {
					isSuccessful = true;
				}

				if (isSuccessful) {
					scope.toastSuccessMessage = $translate.instant(message);
					scope.showToast = true;
				} else {
					scope.toastErrorMessage = $translate.instant(message);
					scope.showErrorToast = true;
				}

				clearToastTimeout = $timeout(function () {
					scope.clearToast();
					scope.clearErrorToast();
				}, time ? time : 3000);
			}

			scope.clearToast = function() {
				scope.showToast = false;
			};

			scope.clearErrorToast = function() {
				scope.showErrorToast = false;
			};

			var toastListener = $rootScope.$on('toast', function (event, args) {
				if (!_.has(args, 'message') || _.get(args, 'message')  === '') {
					return;
				}
				if(_.has(args, 'time')) {
					addToastMessage(args.message, args.success, args.time);
				} else {
					addToastMessage(args.message, args.success);
				}

			});

			scope.$on('$destroy', function() {
				toastListener();
				$timeout.cancel(clearToastTimeout);
			});
		}
	}
})();
